function BookingTimeline({ booking }) {
  const steps = [
    { key: "created", label: "Booking Created" },
    { key: "paid", label: "Payment Successful" },
    { key: "confirmed", label: "Booking Confirmed" },
    { key: "pickup", label: "Bike Picked Up" },
    { key: "return", label: "Bike Returned" },
  ];

  const isCompleted = (step) => {
    if (step === "created") return true;
    if (step === "paid") return booking.paymentStatus === "paid";
    if (step === "confirmed") return booking.bookingStatus === "confirmed" || booking.bookingStatus === "completed";
    if (step === "pickup") return booking.pickupStatus;
    if (step === "return") return booking.returnStatus;
    return false;
  };

  return (
    <div style={styles.timeline}>
      {steps.map((s, index) => (
        <div key={s.key} style={styles.step}>
          <div
            style={{
              ...styles.circle,
              background: isCompleted(s.key) ? "#00c853" : "#ccc",
            }}
          >
            {isCompleted(s.key) ? "✔" : index + 1}
          </div>

          <span
            style={{
              ...styles.label,
              color: isCompleted(s.key) ? "#000" : "#888",
            }}
          >
            {s.label}
          </span>
        </div>
      ))}
    </div>
  );
}

const styles = {
  timeline: {
    display: "flex",
    flexWrap: "wrap",
    gap: "16px",
    marginTop: "15px",
  },
  step: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  circle: {
    width: "28px",
    height: "28px",
    borderRadius: "50%",
    color: "white",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "14px",
    fontWeight: "bold",
  },
  label: {
    fontSize: "14px",
  },
};

export default BookingTimeline;
